"use client"

import React, { createContext, useContext, useState } from "react";

const appContext = createContext();

const AppProvider = ({ children }) => {
    const domain = window.location.origin;
    const [isCameraActive, setIsCameraActive] = useState(false);
    const [totalCheckedIn, setTotalCheckedIn] = useState(`0/0`);

    const value = React.useMemo(() => ({
        domain,
        isCameraActive, setIsCameraActive,
        totalCheckedIn, setTotalCheckedIn,
    }), [
        domain,
        isCameraActive,
        totalCheckedIn,
    ]);

    return (
        <appContext.Provider value={value}>
            {children}
        </appContext.Provider>
    );
};

const useAppContext = () => useContext(appContext);

export { useAppContext, AppProvider };